export default __webpack_public_path__ + "static/collage_image_2-24a311e7a60cf567a8870041ffbb8142.jpg";